import { axiosInstance } from '../../utils/axios-instance'

export const state = () => ({
  diagrams: [],
  slides: [],
  loading: false,
  hasMore: true,
  resultsCount: 0
})

const mutations = {
  setDiagrams (state, diagrams) {
    state.diagrams = diagrams
  },
  concatDiagrams (state, diagrams) {
    state.diagrams = state.diagrams.concat(diagrams)
  },
  setSlides (state, slides) {
    state.slides = slides
  },
  removeSlide (state, slideId) {
    state.slides = state.slides.filter(s => s.id !== slideId)
    const diagramIndex = state.diagrams.findIndex(diagram => diagram.slides.find(slide => slide.id === slideId))
    if (diagramIndex > -1) {
      const diagram = state.diagrams[diagramIndex]
      const diagrams = [...state.diagrams]
      diagram.slides = diagram.slides.filter(slide => slide.id !== slideId)
      if (diagram.slides.length > 0) {
        diagrams[diagramIndex] = diagram
      }
      state.diagrams = diagrams
    }
  },
  concatSlides (state, slides) {
    state.slides = state.slides.concat(slides)
  },
  setLoading (state, loading) {
    state.loading = loading
  },
  setHasMore (state, hasMore) {
    state.hasMore = hasMore
  },
  setResultsCount (state, count) {
    state.resultsCount = count
  },
  setSlideBought (state, slideId) {
    const diagramIndex = state.diagrams.findIndex(diagram => diagram.slides.find(slide => slide.id === slideId))
    if (diagramIndex > -1) {
      const slideIndex = state.diagrams[diagramIndex].slides.findIndex(slide => slide.id === slideId)
      state.diagrams[diagramIndex].slides[slideIndex].can_download = true
      return
    }
    const slideIndex = state.slides.findIndex(slide => slide.id === slideId)
    if (slideIndex > -1) {
      state.slides[slideIndex].can_download = true
    }
  }
}

const actions = {
  async fetchDiagrams ({ commit, rootState }, { page }) {
    const params = {
      categories: rootState.filtering.category,
      tags: rootState.filtering.tag,
      ordering: rootState.filtering.ordering,
      can_download: rootState.filtering.my ? true : '',
      favourite: rootState.filtering.favourites ? true : '',
      page,
      page_size: 10
    }
    if (rootState.filtering.diagram !== '') {
      params.ids = rootState.filtering.diagram.split(',').join('__')
    }
    commit('setLoading', true)
    try {
      const response = await axiosInstance.get('diagrams/', { params })
      commit('concatDiagrams', response.data.results)
      commit('setHasMore', response.data.next !== null)
      return response.data.results
    } catch (error) {
      commit('setHasMore', false)
    } finally {
      commit('setLoading', false)
    }
  },
  async fetchSlides ({ commit, rootState }, { page }) {
    const params = {
      page,
      ordering: rootState.filtering.ordering,
      categories: rootState.filtering.category,
      tags: rootState.filtering.tag,
      can_download: rootState.filtering.my ? true : '',
      favourite: rootState.filtering.favourites ? true : ''
    }
    if (rootState.filtering.slide) {
      params.ids = rootState.filtering.slide.split(',').join('__')
    }
    if (rootState.filtering.query) {
      params.search = rootState.filtering.query
    }
    commit('setLoading', true)
    const response = await axiosInstance.get('/search/', { params })
    commit('setLoading', false)
    commit('concatSlides', response.data.results)
    commit('setHasMore', response.data.next !== null)
    commit('setResultsCount', response.data.count)
  },
  removeSlide ({ commit, state }, { slide }) {
    // search for slide index in diagrams state and remove
    // search for slide indexn is slides state and remove
  }
}

const getters = {
  getGalleryIndex: (state) => (gallery) => {
    console.log('Getting gallery index', gallery)
    if (!state.galleries[gallery]) {
      return null
    } else {
      return state.galleries[gallery]
    }
  },
}

export default { namespaced: true, state, mutations, actions, getters }
